import { render, staticRenderFns } from "./DesktopImg.vue?vue&type=template&id=533f14b9&"
import script from "./DesktopImg.vue?vue&type=script&lang=js&"
export * from "./DesktopImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports